/*
 * @Description: 园区个体
 * @Date: 2024-11-20 11:31:39
 */

import { taxPayment } from '@/api/ajax';
import fields, {
  delDisabled,
  uploadDisabled,
  downloadDisabled
} from './fields';
import search, { kfqy } from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import Add from '../add.vue';

const example = new TableRenderClass({ fields, search });

export const individualMain = () => {
  return [
    {
      name: '完税证明',
      childMenu: [
        example.createPart({
          name: '我发起的',
          search: [
            kfqy({
              key: 'customerName',
              ajax: taxPayment.parkTaxPayment.enterprises,
              prop: {
                label: 'customerName',
                code: 'customerName'
              },
              query: {
                type: 2
              },
              ajaxQuery: 'keyWord'
            }),
            'monthrange',
            'status'
          ],
          showClearAll: true,
          list: data => {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async resolve => {
              const res = await taxPayment.parkTaxPayment.list({
                ...data
              });
              resolve(res);
            });
          },
          defaultQuery: { auditStatus: 0 },
          moreBtnArr: [
            {
              name: '新增完税证明',
              type: 'warning',
              async fn(app, table) {
                table.$xrkDialog({
                  title: '新增完税证明',
                  width: '1000px',
                  showCancel: false,
                  showConfirm: false,
                  $slots: {
                    default: table.$createElement(Add, {
                      props: {
                        addType: 1,
                        useType: 3,
                        saveAjax: taxPayment.parkTaxPayment.saveOrUpdate,
                        customerAjax: taxPayment.parkTaxPayment.selectParkList
                      },
                      on: {
                        confirm: () => {
                          table.saveSuccess();
                          table.$xrkDialog.remove();
                        }
                      }
                    })
                  }
                });
              }
            }
          ],
          requestNow: true,
          fields: [
            'index',
            'customerName',
            'month',
            'startDate',
            'endDate',
            'auditStatus',
            'submitDt',
            {
              label: '操作',
              width: '240px',
              showToolTip: false,
              render: function(h, ctx, r) {
                const vm = ctx.parent;
                return (
                  <div>
                    <el-button
                      type="text"
                      onClick={() => {
                        vm.$xrkDialog({
                          title: '完税证明',
                          width: '1000px',
                          showCancel: false,
                          showConfirm: false,
                          $slots: {
                            default: vm.$createElement(Add, {
                              props: {
                                id: r.id,
                                addType: 2,
                                useType: 3,
                                getAjax: () => {
                                  return taxPayment.parkTaxPayment.view({
                                    id: r.id
                                  });
                                }
                              }
                            })
                          }
                        });
                      }}
                    >
                      查看
                    </el-button>
                    <el-button
                      type="text"
                      disabled={delDisabled(r.auditStatus)}
                      onClick={() => {
                        vm.$confirm('是否删除?', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                        }).then(() => {
                          taxPayment.parkTaxPayment
                            .del({
                              id: r.id
                            })
                            .then(() => {
                              vm.saveSuccess();
                              vm.$message.success('删除成功');
                            });
                        });
                      }}
                    >
                      删除
                    </el-button>
                    <el-button
                      type="text"
                      disabled={uploadDisabled(r)}
                      onClick={() => {
                        vm.$xrkDialog({
                          title: '完税证明',
                          width: '1000px',
                          showCancel: false,
                          showConfirm: false,
                          $slots: {
                            default: vm.$createElement(Add, {
                              props: {
                                id: r.id,
                                addType: 5,
                                useType: 3,
                                getAjax: () => {
                                  return taxPayment.parkTaxPayment.view({
                                    id: r.id
                                  });
                                },
                                saveAjax: taxPayment.parkTaxPayment.saveOrUpdate
                              },
                              on: {
                                confirm: () => {
                                  vm.saveSuccess();
                                  vm.$xrkDialog.remove();
                                }
                              }
                            })
                          }
                        });
                      }}
                    >
                      上传
                    </el-button>
                    <el-button
                      type="text"
                      disabled={downloadDisabled(r.auditStatus)}
                      onClick={() => {
                        taxPayment.parkTaxPayment
                          .download({ id: r.id })
                          .then(() => {
                            vm.$message.success('下载成功，前往下载中心查看');
                          });
                      }}
                    >
                      下载
                    </el-button>
                  </div>
                );
              }
            }
          ]
        })
      ]
    }
  ];
};
